import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboV2DatabaseInstancesResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getDatabaseInstances;

export const DBO_DATABASE_INSTANCES_QUERY_KEY = 'dbo-database-instance-list';

export const getDatabaseInstancesQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => {
  return [DBO_DATABASE_INSTANCES_QUERY_KEY, params] as const;
};

export const useDatabaseInstancesQuery = <
  TSelected = DboV2DatabaseInstancesResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboV2DatabaseInstancesResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getDatabaseInstancesQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
